import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ReaderLocationPageModule } from 'src/app/includes/popups/reader-location/reader-location.module';
import { MyposTerminalComponent } from './mypos-terminal/mypos-terminal.component';
import { StripeBluetoothCardReaderComponent } from './stripe-bluetooth-card-reader/stripe-bluetooth-card-reader.component';
import { StripeTerminalS700Component } from './stripe-terminal-S700/stripe-terminal-S700.component';

@NgModule({
  declarations: [
    StripeTerminalS700Component,
    StripeBluetoothCardReaderComponent,
    MyposTerminalComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule, // Add this line
    ReaderLocationPageModule,
  ],
  exports: [
    StripeTerminalS700Component,
    StripeBluetoothCardReaderComponent,
    MyposTerminalComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CardReaderPaymentModule {}
